import { useUserSetting } from "#app/lib/hooks/use-user-setting";
import type { SearchKind } from "#app/lib/hooks/use-global-search";
import { SEARCH_FILTERS } from "./search-kinds";

// Generic user-settings key the chip selection persists under.
const SEARCH_CHIP_FILTERS_KEY = "global_search_chip_filters";

// Loose JSON from the settings bag → a validated list of kinds.
function normalizeKinds(value: unknown): SearchKind[] {
  if (!Array.isArray(value)) return [];
  const valid = new Set<string>(SEARCH_FILTERS.map((f) => f.value));
  return value.filter(
    (k): k is SearchKind => typeof k === "string" && valid.has(k),
  );
}

/**
 * The scoped-search chip selection. Empty = no kind filter (everything
 * shows). Persisted in the generic user-settings bag via `useUserSetting`,
 * which writes through the Apollo cache — so the selection is remembered
 * across refreshes AND survives a remount (or the sibling desktop-dialog /
 * mobile-drawer consumer) without reverting to a stale cached value.
 */
export function useSearchChipFilters() {
  const { value, setValue } = useUserSetting(SEARCH_CHIP_FILTERS_KEY, normalizeKinds);
  return { storedKinds: value, setSelectedKinds: setValue };
}
